var map = {
	"./logo.png": 2806,
	"./partners/asgardex.png": 1378,
	"./partners/bitget.png": 5440,
	"./partners/cakewallet.png": 3740,
	"./partners/ctrl.png": 5380,
	"./partners/edge.png": 208,
	"./partners/jumper.png": 4990,
	"./partners/keplr.png": 7125,
	"./partners/ledger.png": 3996,
	"./partners/lifi.png": 5157,
	"./partners/okxwallet.png": 7874,
	"./partners/openocean.png": 2557,
	"./partners/rango.png": 9738,
	"./partners/shapeshift.png": 9130,
	"./partners/symbiosis.png": 1891,
	"./partners/thorswap.png": 5129,
	"./partners/thorwallet.png": 5759,
	"./partners/tokenpocket.png": 3066,
	"./partners/trust.png": 9649,
	"./partners/unizen.png": 3330,
	"./partners/vultisig.png": 8172,
	"./partners/zengo.png": 3894,
	"./phone_products.png": 5000,
	"./phone_products_en.png": 7840,
	"./phone_products_ru.png": 2782
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;